import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, List } from '@pella/sash-framework';
import { CTA } from '../../';

const DownloadTabs = ({ data, className, ...other }) => {
	const [activeFaqTab, setActiveFaqTab] = useState(0);

	if (!data?.group?.[0]) return null;

	const onFaqTabClick = (i) => setActiveFaqTab(i);

	return (
		<div
			id={data.anchor_text}
			className={`downloadTabs my-8 xl:my-16 ${className || ''}`}
			{...other}
		>
			<Container>{data.heading && <h2 className='mb-4 text-center font-normal'>{data.heading}</h2>}</Container>

			<div className='mb-4 border-b border-b-gray-15'>
				<Container>
					<List
						bullets='none'
						className='divider-x-gray-15 flex flex-row divide-x overflow-auto xl:justify-center'
					>
						{data.group.map((faq, index) => (
							<li
								key={index}
								className={`relative flex-none px-2 pt-2.5 text-center lg:px-6 ${activeFaqTab == index ? '' : null}`}
							>
								<button
									onClick={() => onFaqTabClick(index)}
									className={`relative block border-b-[5px] bg-transparent px-2 pb-1.5 font-semibold no-underline ${activeFaqTab === index ? 'border-b-primary text-black' : 'border-b-transparent text-gray-60 sm:hover:border-b-primary sm:hover:text-black'}`}
								>
									{faq.heading}
								</button>
							</li>
						))}
					</List>
				</Container>
			</div>

			<Container>
				{data.group.map((ans, index) => (
					<div
						key={index}
						className={activeFaqTab != index ? 'hidden' : ''}
					>
						<List
							bullets='none'
							layout='inline'
							className={`mt-8 ${data.group.length <= 3 ? 'justify-center' : ''}`}
						>
							{ans.cta.map((item, index) => (
								<li
									className='my-2 w-full px-2.5 sm:w-1/2 lg:w-1/4'
									key={index}
								>
									<CTA
										data={item}
										className='inline-flex items-center [&>div]:mr-2'
									/>
								</li>
							))}
						</List>
					</div>
				))}
			</Container>
		</div>
	);
};

DownloadTabs.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default DownloadTabs;
